export default __webpack_public_path__ + "static/media/free-spin-cn.5eef22a9.webp";